import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ASCSortIcon, DESCSortIcon, Swap } from '../../../assets/svg';
import { SORT_TYPE } from '../../../constants';

export const TableHeader = ({
    handleSort,
    columns,
    data,
    stickyColumns = [],
    isScrollableWidth,
}) => {
    const [sortStates, setSortStates] = useState({});

    const handleClick = (index) => {
        const currentSort = sortStates[index] || 'DEFAULT';
        let newSort;
        if (currentSort === 'DEFAULT') {
            newSort = SORT_TYPE.ASC;
        } else if (currentSort === SORT_TYPE.ASC) {
            newSort = SORT_TYPE.DESC;
        } else {
            newSort = SORT_TYPE.ASC;
        }

        setSortStates({
            ...Object.keys(sortStates).reduce((acc, key) => {
                acc[key] = 'DEFAULT';
                return acc;
            }, {}),
            [index]: newSort,
        });

        handleSort(newSort, index);
    };

    return (
        <thead>
            <tr>
                {columns.length > 0 &&
                    columns.map((column, index) => {
                        if (!column?.hideColumn)
                            return column?.sort ? (
                                <th
                                    key={index}
                                    className={`${column.classNameTH} ${isScrollableWidth && (stickyColumns.includes(column.name) || stickyColumns.includes(index)) ? ' sticky-th-left ' : ''}`}
                                >
                                    <span className='me-1'>
                                        {column.customHeader
                                            ? column.customHeader(data)
                                            : column.name}
                                    </span>
                                    {sortStates[index] === 'DEFAULT' || !sortStates[index] ? (
                                        <span title={'Ascending'}>
                                            <Swap handleClick={() => handleClick(index)} />
                                        </span>
                                    ) : sortStates[index] === SORT_TYPE.ASC ? (
                                        <span title={'Descending'}>
                                            <ASCSortIcon handleClick={() => handleClick(index)} />
                                        </span>
                                    ) : (
                                        <span title={'Ascending'}>
                                            <DESCSortIcon handleClick={() => handleClick(index)} />
                                        </span>
                                    )}
                                </th>
                            ) : (
                                <th
                                    key={index}
                                    className={`${column.classNameTH} ${isScrollableWidth && (stickyColumns.includes(column.name) || stickyColumns.includes(index)) ? ' sticky-th-left ' : ''}`}
                                >
                                    {column.customHeader ? column.customHeader(data) : column.name}
                                </th>
                            );
                    })}
            </tr>
        </thead>
    );
};

TableHeader.propTypes = {
    columns: PropTypes.array.isRequired,
    handleSort: PropTypes.func,
};
